import React from 'react';

import { ColumnListContainer } from 'modules/shared-ui/components';
import { useInfiniteScrollPaging } from 'modules/shared/hooks';
import { LightProduct } from '../../../models';
import { ProductThumbnail } from '../../product/product-thumbnail';

import { VerticalProductListProps } from './vertical-product-list-type';

import styles from './vertical-product-list-component.module.css';

export const VerticalProductList: React.FC<VerticalProductListProps> = React.memo(
    ({ products, headerChildren }: VerticalProductListProps) => {
        if (products && products.length > 0) {
            const [listItems] = useInfiniteScrollPaging(products, 20);
            return (
                <div className={styles.container}>
                    <ColumnListContainer
                        options={{
                            mobile: [1, 2],
                            tablet: [2, 3],
                            computer: [3, 4],
                        }}
                        headerChildren={headerChildren}
                        items={listItems}
                        itemRenderer={(product: LightProduct) => {
                            return (
                                <div className={styles.ficheProductContainer} key={product.id}>
                                    <ProductThumbnail product={product} />
                                </div>
                            );
                        }}
                    />
                </div>
            );
        }
        return <div className={styles.container}>Aucun produit ne correspond à ces critères</div>;
    },
);
